import Vue from "vue";
import App from "./App";
import config from "./config";
import router from "./router";
import store from "./store";
import confBrands from "./config/brands/standard";
import functions from "./functions";
import pixels from "./pixels";
import VueAnalytics from "vue-analytics";
import VueLogger from "vuejs-logger";
import MQ from "vue-match-media/src";
import HTMLSanitize from "./plugins/html-sanitize";

const isProduction = process.env.NODE_ENV === "production";

/**
 * Tealeaf desactivado temporalmente
 * 2020-01-14
if (isProduction) {
  require('./libs/tealeaf')
}
 */

Vue.use(VueLogger, {
  isEnabled: true,
  logLevel: isProduction ? "error" : "debug",
  stringifyArguments: false,
  showLogLevel: true,
  showMethodName: true,
  separator: "|",
  showConsoleColors: true
});

Vue.use(config);

if (
  typeof window !== "undefined" &&
  window.__PRERENDER_INJECTED === undefined
) {
  Vue.use(pixels);
  Vue.use(VueAnalytics, {
    id: confBrands.googleAnalyticsId,
    router,
    debug: {
      enabled: !isProduction,
      trace: !isProduction,
      sendHitTask: true
    },
    autoTracking: {
      exception: true,
      pageviewOnLoad: false
    }
  });
  Vue.use(HTMLSanitize);
}

Vue.use(MQ);

Vue.config.productionTip = false;
config.start(() => {
  const BBVA_APP = new Vue({
    el: "#app",
    render: h => h(App),
    mounted: () => {
      if (typeof document !== "undefined") {
        document.dispatchEvent(new Event("x-app-rendered"));
      }
    },
    router,
    store,
    mixins: [functions],
    mq: {
      phone: "(max-width: 450px)",
      tablet: "(max-width: 1024px)",
      desktop: "(min-width: 1024px)"
    }
  });

  // Agregar timestamp de versionado si existe
  let app_version = process.env.VUE_APP_BBVA_VERSION || null;
  if (app_version) {
    BBVA_APP.version = app_version;
  }

  // Exponemos la instancia al scope global
  // Útil para hacer modificaciones desde afuera
  window.BBVA_APP = BBVA_APP;
  return BBVA_APP;
});
